import {api} from "../api/callApi";
import {urlRegion} from "../api/v1";
import {IRegion} from "../varibles/interface";


export const RegionService = {
    gets: () => api.get<IRegion[]>(urlRegion)
}
